import React, { useEffect } from 'react';
import { Modal } from 'antd';
import { Html5QrcodeScanner } from 'html5-qrcode';

interface BarcodeScannerModalProps {
  visible: boolean;
  onCancel: () => void;
  onScan: (result: string) => void;
}

const BarcodeScannerModal: React.FC<BarcodeScannerModalProps> = ({ visible, onCancel, onScan }) => {
  
  useEffect(() => {
    if (!visible) return;

    let scanner: Html5QrcodeScanner | null = null;

    const initScanner = () => {
      scanner = new Html5QrcodeScanner(
        "reader",
        { fps: 10, qrbox: { width: 250, height: 250 } },
        false
      );
      
      const onScanSuccess = (decodedText: string) => {
        onScan(decodedText);
        if (scanner) {
          scanner.clear();
        }
        onCancel();
      };

      const onScanFailure = (error: any) => {};

      scanner.render(onScanSuccess, onScanFailure);
    };

    // Small delay to ensure the modal DOM is ready before injecting scanner
    const timer = setTimeout(initScanner, 100);
    
    return () => {
      clearTimeout(timer);
      if (scanner) {
        scanner.clear().catch((error) => {
          console.error("Failed to clear html5QrcodeScanner. ", error);
        });
      }
    };
  }, [visible, onScan, onCancel]);

  return (
    <Modal
      title="Escanear Código de Barras"
      open={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <div id="reader" style={{ width: '100%' }}></div>
    </Modal>
  );
};

export default BarcodeScannerModal;
